import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  cardWrapper: {
    padding: {
      xs: '16px',
      sm: '48px',
    },
    border: '1px solid',
    borderRadius: '16px',
  },
  image: {
    width: '100%',
    height: '100%',
    maxHeight: '388px',
    maxWidth: '424px',
    borderRadius: '8px',
    display: { xs: 'none', md: 'block' },
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
